import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardActions, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import JumboCardQuick from 'app/components/JumboCardQuick';
import { StyledButton } from 'app/components/v2';
import { enisaRssFeeds } from 'app/store/features/dashboardWidgetSlice';
import { ColorsV2 } from 'app/constants/color';
import FeedListItem from 'app/components/v2/FeedListItem';

const EnisaNews = () => {
  const dispatch = useDispatch();
  const articles = useSelector(state => state.dashboardWidget.enisaFeeds);
  const isEnisaFeedsFetched = useSelector(state => state.dashboardWidget.isEnisaFeedsFetched);
  const visible = useSelector(state => state.dashboardWidget.count);

  const [count, setCount] = useState(6);

  const getSixMonthsAgoDate = () => {
    const currentDate = new Date();
    const sixMonthsAgoDate = new Date(currentDate);
    sixMonthsAgoDate.setMonth(currentDate.getMonth() - `${count}`);
    const formattedDate = sixMonthsAgoDate.toISOString().slice(0, 19) + 'Z';
    return formattedDate;
  };

  useEffect(() => {
    if (!isEnisaFeedsFetched) {
      dispatch(enisaRssFeeds({ date: getSixMonthsAgoDate(), count }));
    }
  }, [count, isEnisaFeedsFetched]);

  return (
    <JumboCardQuick noWrapper>
      <List disablePadding>
        {articles?.map((feed) => (
          <FeedListItem key={feed?.link} feed={feed} />
        ))}
      </List>

      <Divider sx={{ background: ColorsV2.acent }} />
      <CardActions
        sx={{ py: theme => theme.spacing(0.5), display: 'flex', justifyContent: 'space-between' }}
      >
        <Typography variant={'h6'} color={ColorsV2.white} mb={0} fontSize={'0.9em'}>
          {'Last Updated 30 min ago'}
        </Typography>
        {visible !== 9 && (
          <StyledButton
            onClick={() => {
              setCount(prev => prev + 1);
            }}
            name='Save'
            sx={{
              '&:hover': {
                background: ColorsV2.acent,
              },
            }}
          >
            View More
          </StyledButton>
        )}
      </CardActions>
    </JumboCardQuick>
  );
};
export default EnisaNews;
